import React, { useState, useEffect, useRef } from "react";

import CustomiseModal from "../../components/pos/customise-modal";
import {
    productListApi,
    fetchSingleTable,
    tableAddOrdersApi,
} from "../../redux/apis/table-apis";
import errorToast from "../../components/toast/errorToast";
import successToast from "../../components/toast/successToast";
import { Link, useNavigate, useParams } from "react-router-dom";

const AddTableProducts = ({}) => {
    const navigate = useNavigate();
    const [refreshing, setRefreshing] = useState(true);
    const [loading, setLoading] = useState(false);

    const { id } = useParams();
    const [table, setTable] = useState({});

    const [cart, setCart] = useState({});
    const [productList, setProductList] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("all");
    const [searchText, setSearchText] = useState("");
    const customiseModalRef = useRef(null);

    const addToCart = (item) => {
        setCart((prev) => ({
            ...prev,
            [item.id]: {
                ...item,
                qty: (prev[item.id]?.qty || 0) + 1,
                request: prev[item.id]?.request,
            },
        }));
    };

    const removeFromCart = (item) => {
        setCart((prev) => {
            if (!prev[item.id]) return prev;
            if (prev[item.id].qty <= 1) {
                const updated = { ...prev };
                delete updated[item.id];
                return updated;
            }
            return {
                ...prev,
                [item.id]: { ...item, qty: prev[item.id].qty - 1 },
            };
        });
    };

    const getFilteredProducts = () => {
        let products = productList?.products || [];

        if (selectedCategory !== "all") {
            products = products.filter(
                (p) => p.product_category?.id === selectedCategory
            );
        }

        if (searchText.trim() !== "") {
            products = products.filter((p) =>
                p.name.toLowerCase().includes(searchText.toLowerCase())
            );
        }

        return products;
    };

    const handleCustomisationSubmit = (itemId, value) => {
        if (!itemId) return;
        setCart((prev) => ({
            ...prev,
            [itemId]: {
                ...prev[itemId],
                request: value,
            },
        }));
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setRefreshing(true);
        try {
            var tableRes = await fetchSingleTable({
                restaurant_table_id: id,
            });
            var res = await productListApi();
            if (res.status == 200 && tableRes.status == 200) {
                successToast(res.data?.message);
                setProductList(res.data.data);
                setTable(tableRes.data.data);
                setCategories(res.data.data.productCategory);
            } else {
                errorToast(res?.data?.message);
            }
        } catch (error) {
            console.error(error);
            errorToast(error);
        }
        setRefreshing(false);
    };

    const confirmItems = async () => {
        setLoading(true);
        const products = Object.values(cart).map((item) => {
            const qty = item.qty;

            // calculate totals (basic example)
            const total_before_tax = item.price * qty;
            const cgst_total = item.cgst ? item.cgst * qty : 0;
            const sgst_total = item.sgst ? item.sgst * qty : 0;
            const item_total = total_before_tax + cgst_total + sgst_total;

            return {
                ...item,
                qty,
                request: item.request || "",
                total_before_tax,
                cgst_total,
                sgst_total,
                item_total,
            };
        });

        const payload = {
            products,
            restaurant_table_id: table?.id || "",
        };

        try {
            var res = await tableAddOrdersApi(payload);
            if (res.status == 200) {
                successToast(res.data?.message);
                navigate(`/pos/table-details/${id}`);
            } else {
                errorToast(res?.data?.message);
            }
        } catch (error) {
            console.error(error);
            errorToast(error);
        }
        setLoading(false);
    };

    const renderItem = (item) => {
        const qty = cart[item.id]?.qty || 0;
        const request = cart[item.id]?.request || "";

        return (
            <div
                key={item.id}
                className="bg-white border border-gray-200 rounded-xl shadow-sm p-4 flex flex-col hover:shadow-md transition"
            >
                {item.photo && (
                    <img
                        src={item.photo}
                        alt={item.name}
                        className="w-full h-20 object-cover rounded-lg mb-3"
                    />
                )}

                <h3 className="text-base font-semibold text-gray-800">
                    {item.name}
                </h3>
                <p className="text-sm text-gray-600">₹{item.price}</p>

                {qty > 0 && (
                    <div className="mt-2 flex items-center gap-2">
                        <button
                            className="px-2 py-1 text-xs bg-indigo-600 text-white rounded"
                            onClick={() =>
                                customiseModalRef.current?.showDialog(
                                    item.id,
                                    request
                                )
                            }
                        >
                            Customise
                        </button>
                        {request && (
                            <p className="text-xs text-gray-500 truncate">
                                {request}
                            </p>
                        )}
                    </div>
                )}

                <div className="mt-3">
                    {qty === 0 ? (
                        <button
                            className="w-full bg-red-500 text-white py-2 rounded flex items-center justify-center gap-2"
                            onClick={() => addToCart(item)}
                        >
                            ➕ Add
                        </button>
                    ) : (
                        <div className="flex items-center justify-between bg-gray-50 rounded p-1">
                            <button
                                onClick={() => removeFromCart(item)}
                                className="px-3 py-1 bg-red-500 text-white rounded"
                            >
                                -
                            </button>
                            <span className="font-semibold text-gray-800">
                                {qty}
                            </span>
                            <button
                                onClick={() => addToCart(item)}
                                className="px-3 py-1 bg-green-500 text-white rounded"
                            >
                                +
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    if (refreshing) {
        return (
            <div className="h-[90vh] bg-white text-gray-800 flex flex-col">
                <p>loading</p>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 flex flex-col  ">
            <CustomiseModal
                ref={customiseModalRef}
                onSubmit={handleCustomisationSubmit}
            />

            {/* Header */}
            <div className="bg-white  text-gray-700 border-b p-4 flex items-center gap-3">
                <Link
                    to={`/pos/table-details/${id}`}
                    className="p-2 rounded hover:bg-gray-100"
                >
                    ⬅
                </Link>
                <h2 className="text-lg font-bold">
                    {table?.name} : Add Order Items
                </h2>
            </div>

            {/* Filters */}
            <div className="bg-white border-b p-4 flex flex-wrap gap-3 items-center">
                <button
                    onClick={() => setSelectedCategory("all")}
                    className={`px-4 py-2 rounded-lg border ${
                        selectedCategory === "all"
                            ? "bg-red-500 text-white border-red-500"
                            : "bg-white text-gray-700 border-gray-200"
                    }`}
                >
                    All
                </button>
                {categories.map((cat) => (
                    <button
                        key={cat.id}
                        onClick={() => setSelectedCategory(cat.id)}
                        className={`px-4 py-2 rounded-lg border ${
                            selectedCategory === cat.id
                                ? "bg-red-500 text-white border-red-500"
                                : "bg-white text-gray-700 border-gray-200"
                        }`}
                    >
                        {cat.name}
                    </button>
                ))}
                <input
                    type="text"
                    placeholder="Search items"
                    className="ml-auto px-3 py-2 border text-gray-700 rounded-lg bg-gray-100"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                />
            </div>

            {/* Product Grid */}
            <div className=" h-[60vh] overflow-y-auto p-4 grid grid-cols-1 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-4">
                {getFilteredProducts().map((item) => renderItem(item))}
            </div>
            {/* Cart Section */}
            {Object.values(cart).length > 0 && (
                <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 border-t">
                    <div className="max-h-40 overflow-y-auto border rounded-lg p-2 mb-3">
                        {Object.values(cart).map((item) => (
                            <div
                                key={item.id}
                                className="flex items-center gap-3 py-2 border-b last:border-0"
                            >
                                {item.photo && (
                                    <img
                                        src={item.photo}
                                        alt={item.name}
                                        className="w-12 h-12 object-cover rounded"
                                    />
                                )}

                                <div className="flex-1">
                                    <p className="text-sm font-medium">
                                        {item.name}
                                    </p>
                                    {item.request && (
                                        <p className="text-xs text-gray-500">
                                            {item.request}
                                        </p>
                                    )}
                                </div>
                                <p className="text-sm font-semibold">
                                    x {item.qty}
                                </p>
                            </div>
                        ))}
                    </div>
                    <button
                        onClick={() => {
                            confirmItems();
                        }}
                        disabled={loading}
                        className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold"
                    >
                        {loading ? "Loading" : "Confirm Items"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default AddTableProducts;
